import React, { createContext, useContext } from 'react';
import usePaymentHook from '../hooks/usePayment';

export const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
  const payment = usePaymentHook();

  return (
    <PaymentContext.Provider value={payment}>
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayment = () => useContext(PaymentContext);